<template>
  <div>

    <breadcrumbs />

    <div class="content-i">
      <div class="content-box">
        <div class="row pt-4">
          <div class="col-sm-12">
            <!--START - User List -->
            <div class="element-wrapper">
              <h6 class="element-header capitalize">
                {{ t.navigation.market }}
              </h6>
              <div class="element-box-tp">
                <div class="row">
                  <div class="col-12">
                    <a class="pull-right btn btn-primary" @click="openMarketForm()" href="javascript:;">Add Market</a>
                  </div>
                  <div class="col-12">
                    <betMarketLimitations />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <sweet-modal ref="marketForm" width="600" title="Market Details">
      <marketForm :event="0" />
    </sweet-modal>
  </div>
</template>

<script>
    import marketForm from '@/components/stats/match/marketForm'
    import betMarketLimitations from '@/components/feed/markets/betMarketLimitations'
    export default {
        name: 'markets',
        components: {betMarketLimitations, marketForm},
        data () {
            return {
                t: this.$root.t
            }
        },
        methods:{
          openMarketForm(){
            this.$refs.marketForm.open();
          }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/feed/markets/markets.vue